import * as React from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import { DestinationsAutocomplete } from 'lesamis-react-components';
import TagsInput from 'react-tagsinput';
import { Input } from 'src/components/Shared/BsInput';
import * as Api from 'src/api';
import InputErrorClass from 'src/components/Shared/InputErrorClass';
import { CONTENT_TYPES } from '../../../globals';
import 'react-tagsinput/react-tagsinput.css';

class ContentsParams extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      contentsSubtypes: [],
    };
  }

  public async componentDidMount() {
    const { data } = await Api.listContentSubtypes({ limit: 100, order: 'name ASC' });

    this.setState({ contentsSubtypes: data });
  }

  public render() {
    const { values, setFieldValue, handleChange, errors, tags } = this.props;
    function autocompleteRenderInput ({ addTag, ...props }: any) {
      const handleOnChange = (e: any, { newValue, method }: any) => {
        if (method === 'enter') {
          e.preventDefault()
        } else {
          props.onChange(e)
        }
      }

      const inputValue = (props.value && props.value.trim().toLowerCase()) || '';

      const suggestions = tags.filter((tag: any) => {
        return tag.name.toLowerCase().includes(inputValue.toLowerCase());
      });

      return (
        <Autosuggest
          ref={props.ref}
          suggestions={suggestions}
          shouldRenderSuggestions={(value: any) => value && value.trim().length > 0}
          getSuggestionValue={(s: any) => s.slug}
          renderSuggestion={(s: any) => <span style={{ cursor: 'pointer' }}>{s.name}</span>}
          inputProps={{...props, onChange: handleOnChange}}
          onSuggestionSelected={(e: any, { suggestion }: any) => {
            addTag(suggestion.slug)
          }}
          onSuggestionsClearRequested={() => { console.log('a'); }}
          onSuggestionsFetchRequested={() => { console.log('a'); }}
        />
      )
    }

    return (
      <div>
        <Input
          label="Limite"
          value={values.data.contentsSearch.limit}
          name="data.contentsSearch.limit"
          onChange={this.props.handleChange}
          errors={this.props.errors}
          type="number"
        />
        <div className="form-group">
          <label>Tipo</label>
          <select
            className={InputErrorClass({ errors, name: 'data.contentsSearch.type' })}
            name="data.contentsSearch.type"
            onChange={handleChange}
            value={values.data.contentsSearch.type}
          >
            <option value=""></option>
            {
              Object.keys(CONTENT_TYPES).map((key: string, i: number) => {
                return <option key={i} value={key}>{CONTENT_TYPES[key]}</option>
              })
            }
          </select>
          {errors['data.contentsSearch.type'] && <p className="invalid-feedback">{errors['data.contentsSearch.type']}</p>}
        </div>
        <div className="form-group">
          <label>Sub Tipo</label>
          <select
            className={InputErrorClass({ errors, name: 'data.contentsSearch.subtype_id' })}
            name="data.contentsSearch.subtype_id"
            onChange={handleChange}
            value={values.data.contentsSearch.subtype_id}
          >
            <option value=""></option>
            {
              this.state.contentsSubtypes.map((s: any, i: number) => {
                return <option key={i} value={s.id}>{s.name}</option>
              })
            }
          </select>
          {errors['data.contentsSearch.subtype_id'] && <p className="invalid-feedback">{errors['data.contentsSearch.subtype_id']}</p>}
        </div>
        <div className="form-group">
          <label>Destinos</label>
          <DestinationsAutocomplete
            settings={{
              endpoint: 'autocompleteFull',
              multiple: false,
              emptyOnSelect: false,
              clearable: true,
            }}
            defaultSelected={values.data.contentsSearch.destination ? [values.data.contentsSearch.destination] : []}
            onSelected={(selected: any) => {
              if (!selected) {
                return;
              }

              setFieldValue('data.contentsSearch.destination', {
                id: selected.id,
                name: selected.name,
                slug: selected.slug,
                type: selected.type,
              });
            }}
            renderOption={(option: any, i: number) => {
              if (option.type === 'CITY') {
                return (<div key={i}>{option.name}, {option.Country.name}</div>);
              }

              return (<div key={i}>{option.name}</div>);
            }}
            onEmpty={() => setFieldValue('data.contentsSearch.destination', null)}
          />
        </div>
        <div className="form-group">
          <label>Tags</label>
          <TagsInput
            renderInput={autocompleteRenderInput}
            value={values.data.contentsSearch.tags}
            onChange={(tt: string[]) => {
              const allowed = tt.filter((t: any) => {
                return tags.findIndex((tag: any) => tag.slug === t) !== -1;
              });

              setFieldValue('data.contentsSearch.tags', allowed);
            }}
            addKeys={[9, 188, 13]}
            onlyUnique={true}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: any) => ({ tags: state.tags });

export default connect(mapStateToProps)(ContentsParams);



// WEBPACK FOOTER //
// ./src/containers/Module/Types/ContentsParams.tsx